import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

export const CustomTextField = React.forwardRef((props: TextFieldProps, ref: React.ForwardedRef<HTMLInputElement>) => (
  <TextField inputRef={ref} {...props} />
));
